import { IPaginationData } from "@faire/web-api/indigofair/data/IPaginationData";
import { useMemo } from "react";

import { useLoggedOutCategoryPageCatNavResponse } from "@faire/retailer/views/category/__internal__/CategoryPageRoot/__internal__/LoggedOutCategoryPage/__internal__/DataFetching/useLoggedOutCategoryPageCatNav/useLoggedOutCategoryPageCatNavResponse";
import { useLoggedOutCategoryPageRequestPageSize } from "@faire/retailer/views/category/__internal__/CategoryPageRoot/__internal__/LoggedOutCategoryPage/__internal__/hooks/useLoggedOutCategoryPageRequestPageSize";

export const useLoggedOutCategoryPagePaginationData = ():
  | IPaginationData
  | undefined => {
  const requestPageSize = useLoggedOutCategoryPageRequestPageSize();
  const paginationData =
    useLoggedOutCategoryPageCatNavResponse().data?.paginationData;
  return useMemo(() => {
    if (paginationData === undefined) {
      return undefined;
    }
    return IPaginationData.build({
      ...paginationData,
      page_size: requestPageSize,
      page_count: Math.ceil(
        (paginationData.total_results ?? 0) / requestPageSize
      ),
    });
  }, [paginationData, requestPageSize]);
};
